/** PAGE: SHIPMENTS
 * Shipment Constants Data. */
const incotermList = ['EXW', 'FCA', 'FAS', 'FOB', 'CFR', 'CIF', 'CPT', 'CIP', 'DPU', 'DAP', 'DDP'];
const containerSizeList = [
    "12'RF",
    "20'FR",
    "20'GP",
    "20'OT",
    "20'RF",
    "20'TK",
    "40'FR",
    "40'GP",
    "40'HC",
    "40'HF",
    "40'HR",
    "40'NOR",
    "40'OT",
    "40'RF",
    "40'TK",
    "45'HC",
    "45'RH",
    "46'P3",
    "48'HC",
    "53'FT",
    "53'HC",
    'LCL',
    'BULK',
];
const trucking_type = ['-', 'FTL', 'LTL', 'Flatbed', 'Local LTL', 'Special'];
const booking_status = ['-', 'Pending', 'Requested', 'Confirmed'];
const prealert_status = ['Not Sent', 'Sent'];
const isf_status = ['-', 'Received', 'Sent', 'Not on File', 'Bill on File'];
const hbl_release = ['-', 'S.HBL Pending', 'S.HBL Released', 'OBL Pending', 'OBL Released'];
const customs_status = ['Pending', 'Sent', 'Cleared'];
const customs_hold_status = [
    '-',
    'FDA Hold',
    'EPA Hold',
    'CBP Hold',
    'FDA Released',
    'EPA Released',
    'CBP Released',
    'Others',
];
const pierpass_import_status = ['Unpaid', 'Paid'];
const pierpass_export_status = ['Unpaid', 'Claimed', 'Paid'];
const aes_status = ['Pending', 'Submitted'];
const stage_status = ['Pending', 'Picked Up', 'Gated In', 'Loaded', 'Departed'];
const delivery_order_status = ['-', 'Sent', 'Confirmed'];
const proof_status = ['Waiting', 'Received'];
const empty_status = ['Not Returned', 'Emptied', 'Returned'];
const mbl_release = ['Pending', 'Released'];
const arrival_notice_status = ['Waiting', 'Received', 'Sent'];
const ocean_freight_status = ['Pending', 'Payment Requested', 'Payment Sent', 'Confirmed'];
const ocean_freight_accounting = ['Payment Requested', 'Payment Sent'];
const air_freight_status = ['Pending', 'Payment Requested', 'Payment Sent', 'Confirmed'];
const import_service_fee_status = ['Pending', 'Payment Sent', 'Confirmed'];
const ocean_freight_method = ['-', 'Check', 'Wire Transfer', 'ACH Transfer', 'Credit Card'];
const shipping_instruction_status = ['Pending', 'Submitted', 'Confirmed'];
const dg_hazmat_status = ['-', 'Requested', 'Submitted', 'Confirmed'];
const invoice_crdr_status = ['Pending', 'Ready', 'Approved', 'Rejected', 'Sent'];
const client_closure = ['Opened', 'Closed'];
const case_closure = ['In Progress', 'Complete', 'Disputing'];

/** PAGE: SHIPMENTS
 * Shipment progress type list. */
const progressTypeList = [
    { content: 'IN PROGRESS', value: 'inprogress' },
    { content: 'COMPLETE', value: 'complete' },
    { content: 'DISPUTE', value: 'dispute' },
];

/** PAGE: SHIPMENTS
 * Shipment Dispute Constants Data. */
const dispute_type = [
    { id: 1, content: 'MBL', type: [0, 1] },
    { id: 2, content: 'HBL', type: [0, 1] },
    { id: 3, content: 'Container', type: [0, 1] },
    { id: 4, content: 'Alias', type: [0] },
    { id: 5, content: 'MAWB', type: [2, 3] },
    { id: 6, content: 'HAWB', type: [2, 3] },
    { id: 7, content: 'Alias', type: [2, 3] },
    { id: 8, content: 'BOL', type: [4] },
    { id: 9, content: 'Alias', type: [4] },
];
const dispute_disputeType = [
    { id: 1, content: 'Freight Charge' },
    { id: 2, content: 'Clearance' },
    { id: 3, content: 'Trucking' },
    { id: 4, content: 'Handling/Packaging' },
    { id: 5, content: 'Payment Terms' },
    { id: 6, content: 'Insurance' },
];
const dispute_actionTaken = [
    { id: 1, content: 'Reimbursement' },
    { id: 2, content: 'Redelivery' },
    { id: 3, content: 'Discount' },
    { id: 4, content: 'Replacement' },
    { id: 5, content: 'Investigation' },
    { id: 6, content: 'Apology' },
    { id: 7, content: 'Insurance Claim' },
    { id: 8, content: 'Training' },
    { id: 9, content: 'Documentation Update' },
];
const dispute_statusMsg = [
    { id: 1, content: 'Freight Charge Correction Requested.' },
    { id: 2, content: 'Freight Charge Correction Acknowledged.' },
    { id: 3, content: 'Freight Charge Correction Review In Progress.' },
    { id: 4, content: 'Freight Charge Correction Review Completed.' },
    { id: 5, content: 'Freight Charge Correction Accepted.' },
    { id: 6, content: 'Freight Charge Correction Rejected.' },
    { id: 7, content: 'Clearance Correction Requested.' },
    { id: 8, content: 'Clearance Correction Acknowledged.' },
    { id: 9, content: 'Clearance Correction Review in Progress.' },
    { id: 10, content: 'Clearance Correction Review Completed.' },
    { id: 11, content: 'Clearance Correction Accepted.' },
    { id: 12, content: 'Clearance Correction Rejected' },
    { id: 13, content: 'PCS Count Verification Requested.' },
    { id: 14, content: 'PCS Count Verification Acknowledged.' },
    { id: 15, content: 'PCS Count Verification in Progress.' },
    { id: 16, content: 'PCS Count Verification Completed.' },
    { id: 17, content: 'Payment Amount Verification Requested.' },
    { id: 18, content: 'Payment Amount Verification Acknowledged.' },
    { id: 19, content: 'Payment Amount Verification In Progress.' },
    { id: 20, content: 'Payment Amount Verification Completed.' },
    { id: 21, content: 'Insurance Case Claimed.' },
    { id: 22, content: 'Insurance Case Documents Submitted.' },
    { id: 23, content: 'Insurance Case Review In Progress.' },
    { id: 24, content: 'Insurance Case Accepted.' },
    { id: 25, content: 'Insurance Case Rejected.' },
    { id: 26, content: 'Investigation Requested.' },
    { id: 27, content: 'Investigation Acknowledged.' },
    { id: 28, content: 'Investigation In Progress.' },
    { id: 29, content: 'Investigation Completed.' },
    { id: 30, content: 'Dispute Requested.' },
    { id: 31, content: 'Dispute Acknowledged.' },
    { id: 32, content: 'Dispute In Progress.' },
    { id: 33, content: 'Dispute Completed.' },
    { id: 34, content: 'Dispute Accepted.' },
    { id: 35, content: 'Dispute Rejected.' },
];

/**
 * PAGE: SHIPMENTS
 * Apply setting columns and keys.
 */
const oim_preset_columns = [
    'Pre Alert',
    'ISF Filing',
    'Arrival Notice',
    'Collect Charge',
    'HBL Release',
    'Customs',
    'Rail',
    'Delivery Order',
    'Pierpass',
    'Proof',
    'Empty',
    'Invoice',
    'Credit/Debit Note',
];
const oim_preset_keys = [
    'pre_alert',
    'isf',
    'arrival_notice',
    'ocean_freight',
    'hbl_release',
    'customs',
    'intermodal',
    'delivery_order',
    'pierpass',
    'proof',
    'empty',
    'invoice',
    'crdr',
];
const oex_preset_columns = [
    'Delivery Order',
    'Pierpass',
    'Rail',
    'DG/HAZMAT',
    'Shipping Instruction',
    'AES ITN',
    'Stages',
    'Collect Charge',
    'Pre Alert',
    'Invoice',
    'Credit/Debit Note',
];
const oex_preset_keys = [
    'delivery_order',
    'pierpass',
    'intermodal',
    'dg_hazmat',
    'shipping_instruction',
    'aes_itn',
    'stages',
    'ocean_freight',
    'pre_alert',
    'invoice',
    'crdr',
];
const aim_preset_columns = [
    'Pre Alert',
    'Customs',
    'Collect Charge',
    'Import Service Fee',
    'Arrival Notice',
    'Delivery Order',
    'Proof',
    'Invoice',
    'Credit/Debit Note',
];
const aim_preset_keys = [
    'pre_alert',
    'customs',
    'air_freight',
    'import_service_fee',
    'arrival_notice',
    'delivery_order',
    'proof',
    'invoice',
    'crdr',
];
const aex_preset_columns = [
    'Delivery Order',
    'DG/HAZMAT',
    'Shipping Instruction',
    'AES ITN',
    'Stages',
    'Collect Charge',
    'Pre Alert',
    'Invoice',
    'Credit/Debit Note',
];
const aex_preset_keys = [
    'delivery_order',
    'dg_hazmat',
    'shipping_instruction',
    'aes_itn',
    'stages',
    'air_freight',
    'pre_alert',
    'invoice',
    'crdr',
];
const trucking_preset_columns = ['Delivery Order', 'Customs', 'Proof', 'Invoice', 'Credit/Debit Note'];
const trucking_preset_keys = ['delivery_order', 'customs', 'proof', 'invoice', 'crdr'];

/**
 * PAGE: DATA ENTRY (TRADE PARTNER)
 * Partner type list.
 */
const partner_type = [
    { id: 1, content: 'Client' },
    { id: 2, content: 'Forwarder' },
    { id: 3, content: 'Rail Company' },
    { id: 4, content: 'Trucker' },
    { id: 5, content: 'Terminal' },
    { id: 6, content: 'Shipper/Consignee' },
    { id: 7, content: 'Warehouse' },
];
/**
 * PAGE: DATA ENTRY (TRADE PARTNER)
 * Shipment categories.
 */
const SHIPMENT_CATEGORIES = {
    0: 'Ocean Import',
    1: 'Ocean Export',
    2: 'Air Import',
    3: 'Air Export',
    4: 'FTL / LTL',
};
/**
 * PAGE: DATA ENTRY (TRADE PARTNER)
 * Apply setting Note's columns and keys.
 */
const settingOption = [
    { value: 'pre_alert', label: 'Pre Alert', index: [0, 1, 2, 3] },
    { value: 'isf', label: 'ISF Filing', index: [0] },
    { value: 'hbl_release', label: 'HBL Release', index: [0] },
    { value: 'arrival_notice', label: 'Arrival Notice', index: [0, 2] },
    { value: 'aes_itn', label: 'AES ITN', index: [1, 3] },
    { value: 'shipping_instruction', label: 'Shipping Instruction', index: [1, 3] },
    { value: 'stages', label: 'Stages', index: [1, 3] },
    { value: 'ocean_freight', label: 'Collect Charge', index: [0, 1] },
    { value: 'customs', label: 'Customs', index: [0, 2, 4] },
    { value: 'intermodal', label: 'Rail', index: [0, 1] },
    { value: 'delivery_order', label: 'Delivery Order', index: [0, 1, 2, 3, 4] },
    { value: 'pierpass', label: 'Pierpass', index: [0, 1] },
    { value: 'proof', label: 'Proof', index: [0, 2, 4] },
    { value: 'invoice', label: 'Invoice', index: [0, 1, 2, 3, 4] },
    { value: 'crdr', label: 'Credit/Debit', index: [0, 1, 2, 3, 4] },
    { value: 'air_freight', label: 'Air Freight', index: [2, 3] },
    { value: 'dg_hazmat', label: 'DG/HAZMAT', index: [1, 3] },
    { value: 'import_service_fee', label: 'Import Service Fee', index: [2] },
    { value: 'empty', label: 'Empty', index: [0] },
];
/**
 * Progress badge entries per shipment type for note linking.
 * label: badge display text, value: note_entry key stored in DB
 */
const progressNoteEntries = {
    0: [
        { label: 'Pre alert', value: 'pre_alert' },
        { label: 'ISF', value: 'isf' },
        { label: 'Arrival Notice', value: 'arrival_notice' },
        { label: 'Collect Charge', value: 'ocean_freight' },
        { label: 'HBL Release', value: 'hbl_release' },
        { label: 'Customs', value: 'customs' },
        { label: 'Delivery Order', value: 'delivery_order' },
        { label: 'Pierpass', value: 'pierpass' },
        { label: 'Empty', value: 'empty' },
        { label: 'Invoice', value: 'invoice' },
        { label: 'Credit/Debit Note', value: 'crdr' },
    ],
    1: [
        { label: 'Booking Confirmation', value: 'booking_confirmation' },
        { label: 'Delivery Order', value: 'delivery_order' },
        { label: 'Pierpass', value: 'pierpass' },
        { label: 'Shipping Instruction', value: 'shipping_instruction' },
        { label: 'Stages', value: 'stages' },
        { label: 'Collect Charge', value: 'ocean_freight' },
        { label: 'Invoice', value: 'invoice' },
        { label: 'Credit/Debit Note', value: 'crdr' },
    ],
    2: [
        { label: 'Pre Alert', value: 'pre_alert' },
        { label: 'Customs', value: 'customs' },
        { label: 'Collect Charge', value: 'air_freight' },
        { label: 'Import Service Fee', value: 'import_service_fee' },
        { label: 'Arrival Notice', value: 'arrival_notice' },
        { label: 'Delivery Order', value: 'delivery_order' },
        { label: 'Invoice', value: 'invoice' },
        { label: 'Credit/Debit Note', value: 'crdr' },
    ],
    3: [
        { label: 'Booking Confirmation', value: 'booking_confirmation' },
        { label: 'Delivery Order', value: 'delivery_order' },
        { label: 'Shipping Instruction', value: 'shipping_instruction' },
        { label: 'Stages', value: 'stages' },
        { label: 'Collect Charge', value: 'air_freight' },
        { label: 'Invoice', value: 'invoice' },
        { label: 'Credit/Debit Note', value: 'crdr' },
    ],
    4: [
        { label: 'Delivery Order', value: 'delivery_order' },
        { label: 'Customs', value: 'customs' },
        { label: 'Invoice', value: 'invoice' },
        { label: 'Credit/Debit Note', value: 'crdr' },
    ],
};
const progressOption = [
    { value: 'pre_alert', label: 'Pre Alert', shortLabel: 'PA' },
    { value: 'isf', label: 'ISF Filing', shortLabel: 'I' },
    { value: 'hbl_release', label: 'HBL Release', shortLabel: 'H' },
    { value: 'arrival_notice', label: 'Arrival Notice', shortLabel: 'AN' },
    { value: 'shipping_instruction', label: 'Shipping Instruction, AES, DG/HAZMAT', shortLabel: 'SI' },
    { value: 'ocean_freight', label: 'Collect Charge', shortLabel: 'OF' },
    { value: 'customs', label: 'Customs', shortLabel: 'C' },
    { value: 'delivery_order', label: 'Delivery Order', shortLabel: 'DO' },
    { value: 'pierpass', label: 'Pierpass', shortLabel: 'PP' },
    { value: 'invoice', label: 'Invoice', shortLabel: 'IV' },
    { value: 'crdr', label: 'Credit/Debit Statement', shortLabel: 'CD' },
    { value: 'air_freight', label: 'Air Freight', shortLabel: 'AF' },
    { value: 'import_service_fee', label: 'Import Service Fee', shortLabel: 'IS' },
    { value: 'empty', label: 'Empty', shortLabel: 'E' },
    { value: 'mbl_release', label: 'MBL Release, Collect Charge', shortLabel: 'M' },
    { value: 'booking_confirmation', label: 'Booking Confirmation', shortLabel: 'BK' },
    { value: 'portcut', label: 'Port Cut, Stages', shortLabel: 'PC' },
];
/**
 * PAGE: DATA ENTRY (TRADE PARTNER)
 * Tasks by shipment type for apply setting.
 */
const tasksByshipmentType = {
    0: [
        'pre_alert',
        'isf',
        'arrival_notice',
        'ocean_freight',
        'hbl_release',
        'customs',
        'intermodal',
        'delivery_order',
        'pierpass',
        'proof',
        'empty',
        'invoice',
        'crdr',
    ],
    1: [
        'delivery_order',
        'pierpass',
        'intermodal',
        'dg_hazmat',
        'shipping_instruction',
        'aes_itn',
        'stages',
        'ocean_freight',
        'pre_alert',
        'invoice',
        'crdr',
    ],
    2: [
        'pre_alert',
        'customs',
        'air_freight',
        'import_service_fee',
        'arrival_notice',
        'delivery_order',
        'proof',
        'invoice',
        'crdr',
    ],
    3: [
        'delivery_order',
        'dg_hazmat',
        'shipping_instruction',
        'aes_itn',
        'stages',
        'air_freight',
        'pre_alert',
        'invoice',
        'crdr',
    ],
    4: ['delivery_order', 'customs', 'proof', 'invoice', 'crdr'],
};
/**
 * PAGE: DATA ENTRY (TRADE PARTNER)
 * Progress by shipment type for apply setting.
 */
const progressByShipmentType = {
    0: [
        'pre_alert',
        'isf',
        'arrival_notice',
        'mbl_release',
        'hbl_release',
        'customs',
        'delivery_order',
        'pierpass',
        'empty',
        'invoice',
        'crdr',
    ],
    1: [
        'booking_confirmation',
        'delivery_order',
        'pierpass',
        'shipping_instruction',
        'portcut',
        'ocean_freight',
        'invoice',
        'crdr',
    ],
    2: [
        'pre_alert',
        'customs',
        'air_freight',
        'import_service_fee',
        'arrival_notice',
        'delivery_order',
        'invoice',
        'crdr',
    ],
    3: ['booking_confirmation', 'delivery_order', 'shipping_instruction', 'portcut', 'air_freight', 'invoice', 'crdr'],
    4: ['delivery_order', 'customs', 'invoice', 'crdr'],
};

/**
 * PAGE: GUIDELINE
 * Guide category list.
 */
const guideCategory = [
    { id: 1, content: 'Guide' },
    { id: 2, content: 'FAQ' },
];

/** PAGE: ANALYTICS
 * Analytics meta data. */
const periodList = ['Yearly', 'Quarterly', 'Monthly']; // Using in Performance
const transportList = ['Import', 'Export'];
const shipmentType = ['Ocean', 'Air', 'FTL/LTL'];
const transportationList = ['Import', 'Export'];
const dateTypeOption = [
    { id: 'etd', content: 'ETD' },
    { id: 'eta', content: 'ETA' },
    { id: 'feta', content: 'F.ETA' },
];

/**
 * PAGE: DATA EXPORT
 * Operation type list.
 */
const operationType = [
    { id: 0, content: 'Ocean Import' },
    { id: 1, content: 'Ocean Export' },
    { id: 2, content: 'Air Import' },
    { id: 3, content: 'Air Export' },
    { id: 4, content: 'FTL/LTL' },
];

/** PAGE: DATA EXPORT
 * Optional selection for column.
 * index value means where each element should be render and the order of index is oim, oex, aim, aex and trucking. */
const columnOption = [
    // Stakeholders
    [
        { value: 'OPUS REF', index: [0, 1, 2, 3, 4] },
        { value: 'Incoterms', index: [0, 1, 2, 3] },
        { value: 'Client', index: [0, 1, 2, 3, 4] },
        { value: 'Shipper', index: [0, 1, 2, 3, 4] },
        { value: 'Consignee', index: [0, 1, 2, 3, 4] },
        { value: 'Forwarder', index: [0, 1, 2, 3] },
    ],
    // Cargo Details
    [
        { value: 'Booking Number', index: [1, 3] },
        { value: 'MBL', index: [0, 1] },
        { value: 'HBL', index: [0, 1] },
        { value: 'Container', index: [0] },
        { value: 'Container', index: [1] },
        { value: 'Hazmat', index: [0, 1, 2, 3, 4] },
        { value: 'Vessel', index: [0, 1] },
        { value: 'LCL', index: [0, 1] },
        { value: 'Pick Up Number', index: [0] },
        { value: 'Quote Number', index: [0, 1, 2, 3, 4] },
        { value: 'Gate In Date', index: [0, 1, 2, 3, 4] },
        { value: 'Split Cargo', index: [0] },
        { value: 'MAWB', index: [2, 3] },
        { value: 'HAWB', index: [2, 3] },
        { value: 'Air Cargo', index: [2, 3] },
        { value: 'BOL', index: [4] },
        { value: 'Type', index: [4] },
        { value: 'FTL/LTL Cargo', index: [4] },
        { value: 'Reference', index: [0, 1, 2, 3, 4] },
    ],
    // Shipment Schedule
    [
        { value: 'POR', index: [1, 3] },
        { value: 'POL', index: [0, 1] },
        { value: 'POD', index: [0, 1] },
        { value: 'AOL', index: [2, 3] },
        { value: 'AOD', index: [2, 3] },
        { value: 'Final Destination', index: [0, 1] },
        { value: 'Final Destination', index: [2, 3] },
        { value: 'Delivery Location', index: [0, 2] },
        { value: 'DOC CUT', index: [1, 3] },
        { value: 'PORT CUT', index: [1, 3] },
        { value: 'Pick Up', index: [4] },
        { value: 'Deliver To', index: [4] },
        { value: 'ETD', index: [0, 1, 2, 3, 4] },
        { value: 'ETA', index: [0, 1, 2, 3, 4] },
        { value: 'F.ETA', index: [0, 1, 2, 3] },
        { value: 'CY Location', index: [0, 2, 3] },
        { value: 'Rail Location', index: [0, 1] },
        { value: 'CFS Location', index: [0, 1, 2, 3, 4] },
    ],
    // Operation Procedures
    [
        { value: 'Pre Alert', index: [0, 1, 2, 3] },
        { value: 'ISF Filing', index: [0] },
        { value: 'HBL Release', index: [0] },
        { value: 'Customs', index: [0, 2, 4] },
        { value: 'MBL Release', index: [0] },
        { value: 'Arrival Notice', index: [0, 2] },
        { value: 'Booking Confirmation', index: [1, 3] },
        { value: 'DG/HAZMAT', index: [1, 3] },
        { value: 'Shipping Instruction', index: [1, 3] },
        { value: 'AES ITN', index: [1, 3] },
    ],
    // Delivery Procedures
    [
        { value: 'PierPass', index: [0, 1] },
        { value: 'Delivery Order', index: [0, 1, 2, 3, 4] },
        { value: 'Proof', index: [0, 2, 4] },
        { value: 'Empty', index: [0] },
        { value: 'Demurrage', index: [0] },
        { value: 'Stages', index: [1, 3] },
    ],
    // Payment Procedures
    [
        { value: 'Collect Charge', index: [0, 1, 2, 3] },
        { value: 'Import Service Fee', index: [2] },
        { value: 'Invoice', index: [0, 1, 2, 3, 4] },
        { value: 'Credit/Debit Statement', index: [0, 1, 2, 3, 4] },
    ],
    // Case Management
    [
        { value: 'Internal Note', index: [0, 1, 2, 3, 4] },
        { value: 'Client Closure', index: [0, 1, 2, 3, 4] },
        { value: 'Case Closure', index: [0, 1, 2, 3, 4] },
        { value: 'Status', index: [0, 1, 2, 3, 4] },
    ],
];
/** PAGE: DATA EXPORT
 * Column's Category. */
const columnOptionCategory = [
    'Stakeholders',
    'Cargo Details',
    'Shipment Schedule',
    'Operation Procedures',
    'Delivery Procedures',
    'Payment Procedures',
    'Case Management',
];

/**
 * PAGE: PERFORMANCE
 * List of evaluation items: common and individual.
 */
const commonResultList = [
    'Total Number of Employee',
    'Average Labor Index',
    'Top Performing Employee',
    'Low Performing Employee',
];
const personalResultList = ['Name', 'Team', 'Hours Worked', 'Order Processed', 'Labor Index', 'Performance Status'];

/**
 * COMPONENT: DRAG AND DROP
 * File type map.
 */
const fileTypeMap = {
    aac: 'audio/aac',
    abw: 'application/x-abiword',
    arc: 'application/x-freearc',
    avif: 'image/avif',
    avi: 'video/x-msvideo',
    azw: 'application/vnd.amazon.ebook',
    bin: 'application/octet-stream',
    bmp: 'image/bmp',
    bz: 'application/x-bzip',
    bz2: 'application/x-bzip2',
    cda: 'application/x-cdf',
    csh: 'application/x-csh',
    css: 'text/css',
    csv: 'text/csv',
    doc: 'application/msword',
    docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    eot: 'application/vnd.ms-fontobject',
    epub: 'application/epub+zip',
    gz: 'application/gzip',
    gif: 'image/gif',
    htm: 'text/html',
    html: 'text/html',
    ico: 'image/vnd.microsoft.icon',
    ics: 'text/calendar',
    jar: 'application/java-archive',
    jpeg: 'image/jpeg',
    jpg: 'image/jpeg',
    js: 'text/javascript',
    json: 'application/json',
    jsonld: 'application/ld+json',
    mid: 'audio/midi',
    midi: 'audio/x-midi',
    mjs: 'text/javascript',
    mp3: 'audio/mpeg',
    mp4: 'video/mp4',
    mpeg: 'video/mpeg',
    mpkg: 'application/vnd.apple.installer+xml',
    odp: 'application/vnd.oasis.opendocument.presentation',
    ods: 'application/vnd.oasis.opendocument.spreadsheet',
    odt: 'application/vnd.oasis.opendocument.text',
    oga: 'audio/ogg',
    ogv: 'video/ogg',
    ogx: 'application/ogg',
    opus: 'audio/opus',
    otf: 'font/otf',
    png: 'image/png',
    pdf: 'application/pdf',
    php: 'application/x-httpd-php',
    ppt: 'application/vnd.ms-powerpoint',
    pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    rar: 'application/vnd.rar',
    rtf: 'application/rtf',
    sh: 'application/x-sh',
    svg: 'image/svg+xml',
    tar: 'application/x-tar',
    tif: 'image/tiff',
    tiff: 'image/tiff',
    ts: 'video/mp2t',
    ttf: 'font/ttf',
    txt: 'text/plain',
    vsd: 'application/vnd.visio',
    wav: 'audio/wav',
    weba: 'audio/webm',
    webm: 'video/webm',
    webp: 'image/webp',
    woff: 'font/woff',
    woff2: 'font/woff2',
    xhtml: 'application/xhtml+xml',
    xls: 'application/vnd.ms-excel',
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    xml: 'application/xml',
    xul: 'application/vnd.mozilla.xul+xml',
    zip: 'application/zip',
    '3gp': 'video/3gpp; audio/3gpp',
    '3g2': 'video/3gpp2; audio/3gpp2',
    '7z': 'application/x-7z-compressed',
};

export {
    incotermList,
    containerSizeList,
    booking_status,
    prealert_status,
    isf_status,
    hbl_release,
    customs_status,
    customs_hold_status,
    aes_status,
    pierpass_import_status,
    pierpass_export_status,
    stage_status,
    delivery_order_status,
    proof_status,
    empty_status,
    mbl_release,
    arrival_notice_status,
    ocean_freight_status,
    ocean_freight_accounting,
    air_freight_status,
    ocean_freight_method,
    import_service_fee_status,
    shipping_instruction_status,
    dg_hazmat_status,
    invoice_crdr_status,
    client_closure,
    case_closure,
    progressTypeList,
    trucking_type,
    periodList,
    shipmentType,
    transportationList,
    dateTypeOption,
    commonResultList,
    personalResultList,
    dispute_type,
    dispute_disputeType,
    dispute_actionTaken,
    dispute_statusMsg,
    partner_type,
    oim_preset_columns,
    oim_preset_keys,
    oex_preset_columns,
    oex_preset_keys,
    aim_preset_columns,
    aim_preset_keys,
    aex_preset_columns,
    aex_preset_keys,
    trucking_preset_columns,
    trucking_preset_keys,
    fileTypeMap,
    operationType,
    columnOption,
    columnOptionCategory,
    guideCategory,
    settingOption,
    progressOption,
    progressNoteEntries,
    tasksByshipmentType,
    progressByShipmentType,
    transportList,
    SHIPMENT_CATEGORIES,
};
